import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Box,
  MenuItem,
} from "@mui/material";
import useAdd from "../../api/useAdd";
import useFetchObjects from "../../api/useFetchObjects";
import { useTranslation } from "react-i18next";

const StockAdd = ({ open, onClose, token }) => {
  const { t } = useTranslation();
  const { handleAdd, loading, resetForm } = useAdd("shop/stocks", token);

  // Fetch shops and purchase items for selection
  const { data: shops, loading: shopLoading } = useFetchObjects(
    ["shop"],
    "shop/shop",
    token
  );
  const { data: purchaseItems, loading: purchaseItemLoading } = useFetchObjects(
    ["purchase_item"],
    "shop/purchase_items",
    token
  );

  const [selectedShop, setSelectedShop] = useState("");
  const [selectedPurchaseItem, setSelectedPurchaseItem] = useState("");
  const [quantity, setQuantity] = useState("");

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("shop", selectedShop);
    formData.append("purchase_item", selectedPurchaseItem);
    formData.append("quantity", quantity);
    handleAdd(formData);
  };

  useEffect(() => {
    if (resetForm) {
      setSelectedShop("");
      setSelectedPurchaseItem("");
      setQuantity("");
      onClose();
    }
  }, [resetForm, onClose]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t("stock.addStock")}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate sx={{ mt: 1 }}>
          <TextField
            select
            margin="dense"
            label={t("stock.selectShop")}
            fullWidth
            required
            value={selectedShop}
            onChange={(e) => setSelectedShop(e.target.value)}
          >
            {shopLoading ? (
              <MenuItem value="">
                <CircularProgress size={20} />
              </MenuItem>
            ) : (
              (shops || []).map((shop) => (
                <MenuItem key={shop.id} value={String(shop.id)}>
                  {shop.name}
                </MenuItem>
              ))
            )}
          </TextField>
          <TextField
            select
            margin="dense"
            label={t("stock.selectPurchaseItem")}
            fullWidth
            required
            value={selectedPurchaseItem}
            onChange={(e) => setSelectedPurchaseItem(e.target.value)}
          >
            {purchaseItemLoading ? (
              <MenuItem value="">
                <CircularProgress size={20} />
              </MenuItem>
            ) : (
              (purchaseItems || []).map((item) => (
                <MenuItem key={item.id} value={String(item.id)}>
                  {item.product && item.product.name
                    ? item.product.name
                    : t("stock.unknownPurchaseItem")}
                </MenuItem>
              ))
            )}
          </TextField>
          <TextField
            margin="dense"
            label={t("stock.quantity")}
            type="number"
            fullWidth
            required
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={loading}>
          {t("stock.cancel")}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={
            loading || !selectedShop || !selectedPurchaseItem || !quantity
          }
          sx={{ minWidth: 100 }}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            t("stock.submit")
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StockAdd;
